(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {  //va gestito (o fatto passare) il 302 (controllo Location e ricarico home landing per far scattare shibboleth)
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('uniromaLandingApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
